<template>
    <div>
        <video id="camera" width="564" height="376" style="display: none;"></video>
        <canvas id="picture" width="564" height="376" style="display: none;"></canvas>
        <!--<form>-->
        <!--<button type="button" id="shutter">シャッター</button>-->
        <!--</form>-->

        <ul id="photolist">
            <li>
                <div class="mb5 photo_background">
                    <a @click="meetingUrlClick(userInfo.meeting_url)" v-on:mouseover="mouseAction('url'+ userInfo.user_id, true)" v-on:mouseleave="mouseAction('url'+ userInfo.user_id, false)">
                        <p class="user_name uk-text-small">{{userInfo.name}}</p>
                        <div class="user_name_box"></div>

                        <img class="user_image my_image" id="my_image" :src="'storage/images/' + userInfo.image_name" alt="" >
                        <img v-if="!resting" class="user_effect_image">
                        <div v-else class="user_resting ">
                          <img class="user_rest_image" src="images/resting.png" alt="休憩中の画像">
                        </div>
                        <p class="hover_meeting_url" :id="'url'+ userInfo.user_id">{{userInfo.meeting_url}}</p>
                    </a>
                </div>
              <button v-if="resting" title="休憩を終了してカメラオンされます" type="button" @click="stopRestTime()" class="uk-button uk-button-default uk-button-small" style="width: 49%; border-radius: 30px;">休憩終了</button>
              <button v-else title="カメラがオフになり60分後に自動でカメラオンされます" type="button" @click="takeRestTime()" class="uk-button uk-button-default uk-button-small" style="width: 49%; border-radius: 30px;">休憩</button>
            </li>

            <li v-for="(member, index) in memberInfo" :key="member.user_id">
                <div class="mb5 photo_background">
                    <a @click="meetingUrlClick(member.meeting_url)" v-on:mouseover="mouseAction('url'+ member.user_id, true)" v-on:mouseleave="mouseAction('url'+ member.user_id, false)">
                        <p class="user_name uk-text-small">{{member.name}}</p>
                        <div class="user_name_box"></div>
                        <img class="user_image" :src="'storage/images/' + member.image_name">
                        <img class="user_effect_image">
                        <p class="hover_meeting_url" :id="'url'+ member.user_id">{{member.meeting_url}}</p>
                    </a>
                </div>
                <button type="button" id="knock" @click="knock(member.user_id)" class="uk-button uk-button-default uk-button-small" style="width: 49%; border-radius: 30px;">Knock</button>
                <button type="button" id="meeting" @click="meeting(member.user_id)" class="uk-button uk-button-default uk-button-small" style="width: 49%; border-radius: 30px;">call</button>
            </li>
        </ul>

        <div class="" id="chat-wrap">
            <ul class="chat-area" id="chat-area">
                <li v-for="(history, index) in messageHistory">
                    <div v-if="history.user_id !== userInfo.user_id" class="message-name-left">
                        <span v-if="history.name" >{{history.name}}</span>
                        <span v-else>{{history.user_name}}</span>
                        <span :id="[history.chat_id ? 'chat_id_' + history.chat_id : '']" :class='[history.user_read_chat_id ? "read" : "unread"]' :data-chat-id="history.chat_id">●</span>
                        <br />
                        <div class="message-text-left message-text"><span v-html="history.message"></span></div>
                        <br />
                        <span class="chat_date">{{history.created_at | moment}}</span>
                    </div>
                    <div v-if="history.user_id === userInfo.user_id" class="message-name-right">
                        {{history.name}}<br />
                        <div class="message-text-right message-text"><span v-html="history.message"></span></div>
                        <br />
                        <span class="chat_date">{{history.created_at | moment}}</span>
                    </div>
                    <div v-bind:class="{ mymessage:history.user_id === userInfo.user_id }"></div>
                </li>
            </ul>

            <div class="chat-menu-area">
                <ul>
                    <li @click="selectMention()" class="to">To</li>
                </ul>
            </div>
            <div id="chat-modal-mention" class="display-none">
                <ul>
                    <li v-for="(member, index) in memberInfo" :key="member.user_id">
                        <div @click="selectMentionTarget(member)">{{member.name}}</div>
                    </li>
                </ul>
                <div class="blowoff"></div>
            </div>

            <div class="uk-position-relative chat_input_wrap">
                <textarea name="" v-bind:disabled="this.chatProcessing" id="chat_input" class="uk-textarea mb5" cols="10" rows="3" v-model="message" @keydown.13="myKeydown" placeholder="Command(Ctrl) + Enterで送信"></textarea>
            </div>
            <button type="button" v-bind:disabled="this.chatProcessing" class="uk-button uk-button-primary uk-button-small chat_send_button" @click="sendMessage">送信</button>
        </div>

    </div>
</template>

<style>
.read {
    display: none;
}
.unread {
    color: #f96f2b;
}
.user_resting {
  width: 282px;
  text-align: center;
}

.user_resting .user_rest_image {
  max-width: 30%;
  margin-top: 60px;
}

</style>

<script>
import {getCookieValue} from '../util'
import {setCookie} from '../util'

export default {
    data() {
        return {
            photoWidth: 564,
            photoHeight: 376,
            intervalBeforeDate: Date.now(),
            intervalTime: 30000,
            timerId: null,
            uikitNotifConfig: {
                status: 'warning',
                pos: 'bottom-center',
                timeout: 3000
            },
            hoverMeetingUrl: false,
            message: '',
            chatProcessing: false,
            chat_area_id_name: 'chat-area',
            resting: false,
            restTime: 3600000
        }
    },
    filters: {
        moment: function (date) {
            return moment(date).format('M月D日 HH:mm');
        }
    },
    computed: {
        userInfo() {
            return this.$store.state.auth.user
        },
        token () {
            return this.$store.state.auth.token
        },
        memberInfo() {
            return this.$store.state.photo.member
        },
        serviceWorkerStatus() {
            return this.$store.state.serviceWorker.serviceWorkerStatus
        },
        messageHistory() {
            return this.$store.state.message.history
        },
        lastChatId() {
            return this.$store.state.message.lastChatId
        },
        chatAreaObj() {
            return $('#chat-area')
        },
        newChat() {
            return this.$store.state.message.newChat
        }
    },
    methods: {
        takePicture() {
            // 休憩中なら写真撮影しない
            if (this.resting) return;

            const image_name = this.userInfo.image_name
            const canvas = document.querySelector("#picture");
            const video  = document.querySelector("#camera");
            const userInfo = this.userInfo

            /** カメラ設定 */
            const constraints = {
                audio: false,
                video: {
                    width: this.photoWidth,
                    height: this.photoHeight,
                    facingMode: "user"   // フロントカメラを利用する
                    // facingMode: { exact: "environment" }  // リアカメラを利用する場合
                }
            };

            // 撮影、アップロード
            navigator.mediaDevices.getUserMedia(constraints)
                .then( (stream) => {
                    const ctx = canvas.getContext("2d");

                    video.srcObject = stream;
                    video.onloadedmetadata = (e) => {
                        video.play();
                        setTimeout( () => {
                            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                            canvas.toBlob(function(blob) {
                                const token = getCookieValue('token')

                                var formData = new FormData();
                                formData.append('photo', blob);
                                formData.append('api_token', token);
                                formData.append('image_name', image_name);
                                formData.append('user_id', userInfo.user_id);

                                // ユーザー自身の画像をアップロード
                                axios.post('/api/photo/upload', formData, {
                                        headers: { 'content-type': 'multipart/form-data' }
                                    })
                                    .then(res => {
                                        if (res.data.errors) {
                                            console.log(res.data.errors)
                                            return
                                        }
                                    }).catch(error => {
                                        new Error(error)
                                });
                            }, 'image/jpeg', 0.95);

                        }, 800);
                        // setTimeout( () => {
                        //     // カメラを停止
                        //     video.srcObject.getTracks().forEach(track => track.stop());
                        // }, 800);
                    };

                })
                .catch( (err) => {
                    console.log(err.name + ": " + err.message);
                });

        },
        // 休憩表示になりカメラオフ
        takeRestTime() {
          // 休憩フラグを立てる
          this.resting = true;
          // 60分後に自動で休憩終了
          setTimeout(this.stopRestTime, this.restTime);
          // 休憩中画像の切り替え
          // $('#my_image').attr('src', 'images/resting.png');
          $('#my_image').next('user_effect_image').attr('src', 'images/resting.png');
          // this.ReloadImageLinks();
        },
        // 休憩終了
        stopRestTime() {
          if (!this.resting) return;
          this.resting = false;
          this.ReloadImageLinks();
        },
        async getMember() {
            await this.$store.dispatch('photo/getMember', {
                user_id: this.userInfo.user_id,
                api_token: getCookieValue('token'),
            })
            if (this.$store.state.photo.fail_count) {
                this.logout()
            }

            this.ReloadImageLinks()
        },
        ReloadImageLinks() {
            // 画像のリンクを再読み込み / エフェクト処理
            var src;

            const curves = this.$store.getters['photo/vintageCurves']
            $(".user_image").each(function(i, elem) {
                src = $(elem).attr('src')
                src = src.replace(/\?.*$/,"")
                $(elem).attr('src', src + '?' + (new Date()).getTime())

                var user_effect_image = $(elem).next('.user_effect_image')

                const effect = {
                    curves: curves,
                    screen: {r: 227, g: 12, b: 169, a: 0.15},
                    // brightness: 0.1,         // float between -1 and 1, default: 0
                    // contrast: 0.1,           // float between -1 and 1, default: 0
                };
                vintagejs(src + '?' + (new Date()).getTime(), effect)
                    .then(res => {
                        user_effect_image.attr('src', res.getDataURL())
                    });
            });
        },
        async logout () {
            await this.$store.dispatch('auth/logout')
            location.href='/login';
            // this.$router.push('/login')
        },
        intervalProcess() {
            if (this.$route.path !== '/') return

            // 定期撮影
            this.takePicture()
            // メンバーの取得・表示
            this.getMember()
        },
        // push通知 knock
        async knock(user_id) {
            await this.$store.dispatch('serviceWorker/sendPushNotifKnock', {
                user_id: user_id,
                api_token: getCookieValue('token'),
            })

            this.uikitNotifConfig.message = (this.serviceWorkerStatus) ? '通知しました' : '通知失敗'
            UIkit.notification(this.uikitNotifConfig)
        },
        // push通知 call
        async meeting(user_id) {
            if (this.userInfo.meeting_url === '') {
                this.uikitNotifConfig.message = 'Meeting URLを登録してください。'
                UIkit.notification(this.uikitNotifConfig)
                return
            }

            await this.$store.dispatch('serviceWorker/sendPushNotifMeeting', {
                user_id: user_id,
                api_token: getCookieValue('token'),
            })

            this.uikitNotifConfig.message = (this.serviceWorkerStatus) ? '通知しました' : '通知失敗'
            UIkit.notification(this.uikitNotifConfig)
        },
        meetingUrlClick(meeting_url) {
            if (meeting_url !== '') open(meeting_url, "_blank" )
        },
        mouseAction(id, flag){
            const obj =  $('#' + id)
            flag ? obj.show() : obj.hide()
        },
        async sendMessage() {
            if (this.message === '') return

            // chatのtextareaをdisabledにする
            this.chatProcessing = true

            const result = await this.$store.dispatch('message/postMessage', {
                user_id: this.userInfo.user_id,
                message: this.message,
                api_token: getCookieValue('token'),
            })
            if (result) this.message = ''

            // chatのtextareaのdisabledの解除
            this.chatProcessing = false
        },
        async connectChannel() {
            if (this.$store.state.message.connectStatus) return
            const connect_result = await Echo.private("user_group." + this.userInfo.user_group_id).listen("MessageRecieved", e => {
                // メッセージを受信
                this.addHistory(e.data)
            });
            if (connect_result) this.$store.state.message.connectStatus = true
        },
        async getMessageHistory() {
            if (! this.$store.state.message.history) {
                await this.$store.dispatch('message/getMessageHistory', {
                    api_token: getCookieValue('token'),
                })
            }

            // チャットエリアで最下部に移動
            const chat_height = document.getElementById('chat-area').scrollHeight
            this.moveScroll(chat_height)
        },
        async addHistory(data) {
            data.user_id = this.userInfo.user_id
            await this.$store.dispatch('message/addHistory', data)
            // チャットエリアで最下部に移動
            const chat_height = document.getElementById('chat-area').scrollHeight
            this.moveScroll(chat_height)
        },
        moveScroll(position) {
            document.getElementById('chat-area').scrollTop = position
        },
        myKeydown(e) {
            // Enter + ShiftかCommand(Ctrl)でメッセージ送信処理を行う
            if ((e.ctrlKey && !e.metaKey) || (!e.ctrlKey && e.metaKey) || (e.shiftKey)) {
                $('#chat_input').blur()
                this.sendMessage()
            }
        },
        // chatのToボタン押下
        selectMention() {
            // $('#chat-modal-mention').show()
        },
        selectMentionTarget(member) {
            this.message = this.message + '[To: ' + member.user_id + ']' + member.name + 'さん' + '\n'
        },
        // chatエリア内のスクロールイベントを取得し、既読処理を行う
        scrollReadMessage(chatAreaScroll) {
            const chat_area_id_name = this.chat_area_id_name;
            const store = this.$store
            chatAreaScroll.addEventListener('scroll', function(){
                const chat_cookie_name = 'user_read_chat_ids';
                var cookie_user_read_chat_ids = getCookieValue(chat_cookie_name).split(',');
                // chatエリアの上部位置
                const chatAreaTop = document.getElementById(chat_area_id_name).getBoundingClientRect().top;
                // chatエリアの下部位置
                const chatAreaBottom = document.getElementById(chat_area_id_name).getBoundingClientRect().bottom;
                // 未読メッセージを取得
                const unread_elements = $('#' + chat_area_id_name).find('.unread');

                unread_elements.each(function(index, element){
                    // var chatId = Number(unreadObj.data('chat-id'));
                    var chatId = Number(element.id.replace('chat_id_', ''));

                    // cookieに既読chat_idが存在したらreturn（apiへの重複既読処理を防ぐ為）
                    if (cookie_user_read_chat_ids.includes(String(chatId))) return
                    if (cookie_user_read_chat_ids.includes(chatId)) return

                    // chatエリア内に表示されているメッセージのみを抽出
                    var elTop = element.getBoundingClientRect().top;
                    if (chatAreaTop < elTop && chatAreaBottom > elTop) {
                        cookie_user_read_chat_ids.push(chatId);
                        window.setTimeout(function(){
                            // apiへの既読処理
                            store.dispatch('message/readMessage', {
                                chat_id: chatId,
                                api_token: getCookieValue('token'),
                            })
                        }, 2000);

                    }
                })

                if (cookie_user_read_chat_ids.length) {
                    // 既読処理をしたchat_idをcookieに保存
                    setCookie(chat_cookie_name, cookie_user_read_chat_ids, 1)
                }
                if (cookie_user_read_chat_ids.length > 39) {
                    // 一定数溜まったらcookieを削除
                    setCookie(chat_cookie_name, '', 1)
                }
            });
        }
    },
    mounted() {
        /**
         * シャッターボタン
         */
        // document.querySelector("#shutter").addEventListener("click", () => {
        //     this.takePicture();
        // });

        // 撮影・メンバー取得
        this.takePicture()
        this.getMember()

        // 定期撮影、メンバーの取得・表示
        clearInterval(this.$store.state.photo.timerId)
        this.$store.state.photo.timerId = setInterval(this.intervalProcess , this.intervalTime)

        // chat接続
        this.connectChannel()

        // 過去のchatの履歴取得
        this.getMessageHistory()

        // チャットエリアでトップにスクロールしたら過去履歴を取得
        const store = this.$store
        this.chatAreaObj.scroll(store, function() {
            const scroll = $(this).scrollTop()
            if (scroll !== 0) return

            store.state.message.chatAreaHeight = $(this)
            store.dispatch('message/getMessageHistory', {
                last_chat_id: store.state.message.lastChatId,
                api_token: getCookieValue('token'),
            })
        });

        // チャット入力画面でShift + Enterを押した時にアクティブを外す
        $(window).keydown(function(e){
            if(! event.shiftKey || e.keyCode !== 13) return
            if ($(':focus').attr("id") === 'chat_input') {
                return false;
            }
        });

        // チャットエリアの高さを動的に変更
        var height = $(window).height()
        const heightMinus = 273;
        $('#chat-area').css('height', height-heightMinus + 'px')
        $(window).resize(function(){
            height = $(window).height();
            $('#chat-area').css('height', height-heightMinus + 'px')
            // チャットエリアでスクロールを常に最下部に移動
            document.getElementById('chat-area').scrollTop = document.getElementById('chat-area').scrollHeight
        });

        // クリック時全般の制御
        $(document).on('click touchend', function(event) {
            const class_name = $(event.target).attr('class')

            if (class_name === 'to') {
                // Toをクリックした時メンションモーダルを表示
                $('#chat-modal-mention').show()
            } else {
                // To以外の箇所をクリックしたらメンションモーダルを閉じる
                if (!$(event.target).closest('#chat-modal-mention').length) {
                    $('#chat-modal-mention').hide()
                }
            }
        });

        // chatエリア内のスクロールイベントを取得し、既読処理を行う
        const chatAreaScroll = window.document.getElementById(this.chat_area_id_name);
        this.scrollReadMessage(chatAreaScroll);

    },
    created () {
    }
}

</script>

